import { useEffect, useState } from 'react'
import styles from './pmndp-enhanced.module.css';
import { pmndpAPI } from "../../../services/pmndp.api";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";
import { formatToInputDate } from "../../../helpers/common-helper";

const PMNDPRegistrationForm = ({onClose}) => {
    const labels = {
        pmndpRegistration: "PMNDP Registration",
        personalDetails: "Personal Details",
        registrationDate: "Registration Date",
        patientName: "Patient Name",
        enterPatientName: "Enter Patient Name",
        dateOfBirth: "Date Of Birth",
        age: "Age",
        patientHeight: "Patient Height",
        patientWeight: "Patient Weight",
        gender: "Gender",
        male: "Male",
        female: "Female",
        transgender: "Transgender",
        contactDetails: "Contact Details",
        mobileNumber: "Mobile Number",
        emailId: "Email ID",
        emergencyContactNo: "Emergency Contact No.",
        address: "Address",
        state: "State",
        selectState: "Select State",
        district: "District",
        selectDistrict: "Select District",
        dialysisDetails: "Dialysis Details",
        dialysisSupportType: "Dialysis Support Type",
        selectType: "Select Type",
        procedureType: "Procedure Type",
        selectProcedureType: "Select Procedure Type",
        dialysisMode: "Dialysis Mode",
        hemodialysis: "Hemodialysis",
        peritonealDialysis: "Peritoneal dialysis",
        recommendedDialysisCount: "Recommended dialysis count (per week)",
        patientCounselledApp: "Patient is counselled for using Mobile Application",
        otherDetails: "Other Details",
        belowPoverty: "Below Poverty (BPL)",
        yes: "Yes",
        bplOption: "BPL Option",
        selectBplOption: "Select BPL Option",
        save: "Save",
        close: "Close",
        registrationDateRequired: "Registration date is required",
        heightRequired: "Height is required",
        weightRequired: "Weight is required",
        validEmail: "Please enter a valid email",
        emergencyContactRequired: "Emergency contact is required",
        validMobileNumber: "Enter a valid 10-digit mobile number",
        stateRequired: "State is required",
        districtRequired: "District is required",
        dialysisTypeRequired: "Dialysis type is required",
        procedureTypeRequired: "Procedure type is required",
        dialysisModeRequired: "Dialysis mode is required",
        dialysisCountRequired: "Dialysis count is required",
        bplSelectionRequired: "BPL selection is required",
        bplOptionRequired: "BPL option is required",
        pleaseSelectState: "Please select a state.",
        failedFetchDistricts: "Failed to fetch districts. Please try again.",
        errorFetchingDistricts: "Error fetching districts",
        failedLoadFormData: "Failed to load form data",
        patientRegistrationSuccess: "Patient registration successful!",
        failedRegisterPatient: "Failed to register patient. Please try again.",
        errorDuringRegistration: "Error occurred during registration"
    };

    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [dialysisSupportTypes, setDialysisSupportTypes] = useState([]);
    const [procedureTypes, setProcedureTypes] = useState([]);
    const [bploptions, setBplOptions] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [patientForm, setPatientForm] = useState({});
    const [errors, setErrors] = useState({});
    const navigate = useNavigate(); // React Router hook for navigation

    const calculateAge = (birthDate) => {
        if (!birthDate) return 0; // Return 0 if birthDate is not provided
        const birthDateObj = new Date(birthDate);
        const today = new Date();
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();
        const dayDiff = today.getDate() - birthDateObj.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
        return age;
    };
    useEffect(() => {
        // Initialize patientForm with blank values
        const blankForm = {
            gender: "Male",
            age: "",
            height: "",
            weight: "",
            is_counselled_for_app: false,
            patient_date: new Date().toISOString().split('T')[0],
            patient_name: "",
            mobile: "",
            email: "",
            health_id: "",
            procedure_type: "",
            is_bpl: 1,
            dialysis_type_id: "",
            dob: "",
            dialysis_mode: 1,
            abha_address: "",
            state_id: "",
            address: "",
            district_id: "",
            emergency_contact: "",
            bpl_option_detail: "",
            dialysis_count: "",
            selected_abha_number: "",
            profile_photo: ""
        };
        const userDetails = localStorage.getItem("orignalBeneficiaryData");
        if (userDetails) {
            try {
                const abhaData = JSON.parse(userDetails);
                let calculatedAge;
                
                if(abhaData?.dob){
                    const [day, month, year] = abhaData.dob.split('-');
                    calculatedAge = calculateAge(new Date(`${year}-${month}-${day}`));
                }
                if(abhaData?.statelgd){
                    districtsList(abhaData.statelgd);
                }
                
                blankForm.health_id = abhaData.hidn || "";
                blankForm.abha_address = abhaData.hid || "";
                blankForm.patient_name = abhaData.name || "";
                blankForm.dob = formatToInputDate(abhaData.dob) || "";
                blankForm.age = calculatedAge || 0;
                blankForm.gender = abhaData.gender === 'M' ? 'Male' : abhaData.gender === 'F' ? 'Female' : 'Other';
                blankForm.mobile = abhaData.mobile || "";
                blankForm.email = abhaData.email || "";
                blankForm.address = abhaData.address || "";
                blankForm.profile_photo = abhaData.kycphoto || "";
                blankForm.district_id = abhaData.distlgd || "";
                blankForm.state_id = abhaData.statelgd || "";
                blankForm.selected_abha_number = abhaData.hidn || "";
            } catch (parseError) {
                console.error('Error parsing localStorage data:', parseError);
            }
        }
        setPatientForm(blankForm);

    }, []);

   

    useEffect(() => {
        setIsPageLoading(false);
    }, [states, dialysisSupportTypes, bploptions]);

    useEffect(() => {
        setIsPageLoading(true);
        const fetchDropdowns = async () => {
            try {
                const stateResponse = await pmndpAPI.getStates();
                if (stateResponse.success) {
                    setStates(stateResponse.data);
                }
                const typesResponse = await pmndpAPI.getDialysisTypes();
                if (typesResponse.success) {
                    setDialysisSupportTypes(typesResponse.data);
                }

                const bplResponse = await pmndpAPI.getBplOptions();
                if (bplResponse.success) {
                    setBplOptions(bplResponse.data);
                }

                const procedureResponse = await pmndpAPI.getProcedureTypes();
                if (procedureResponse.success) {
                    setProcedureTypes(procedureResponse.data);
                }
            } catch (error) {
                console.error("Error fetching dropdown data:", error);
                toast.error(labels.failedLoadFormData);
            } finally {
                setIsPageLoading(false);
            }
        };

        fetchDropdowns();
      
    }, [labels.failedLoadFormData]);

    const districtsList = async (stateId) => {
        if (!stateId) {
            toast.error(labels.pleaseSelectState);
            setDistricts([]);
            return;
        }
        
        setIsPageLoading(true);
        try {
            const dtresponse = await pmndpAPI.getDistricts({ stateId: stateId });
            if (dtresponse.success) {
                setDistricts(dtresponse.data);
            } else {
                toast.error('Error in fetching districts');
                setDistricts([]);
            }
        } catch (error) {
            console.error('Error fetching districts:', error);
            toast.error(labels.errorFetchingDistricts);
            setDistricts([]);
        } finally {
            setIsPageLoading(false);
        }
    }
    const handleStateChange = async (e) => {
        const selectedStateId = e.target.value;
        
        // Update the form state with the selected state
        setPatientForm({
            ...patientForm,
            state_id: selectedStateId,
            district_id: "" // Reset district when state changes
        });
        
        // Clear any existing state error
        setErrors({
            ...errors,
            state_id: '',
            district_id: ''
        });
        
        if (selectedStateId) {
            await districtsList(selectedStateId);
        } else {
            toast.error(labels.pleaseSelectState);
            setDistricts([]);
        }
    }

    // Validate input fields
    const validate = () => {
        const newErrors = {};

        if (!patientForm.patient_date) {
            newErrors.patient_date = labels.registrationDateRequired;
        }

        if (!patientForm.height || isNaN(patientForm.height)) {
            newErrors.height = labels.heightRequired;
        }

        if (!patientForm.weight || isNaN(patientForm.weight)) {
            newErrors.weight = labels.weightRequired;
        }

        if (patientForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(patientForm.email)) {
            newErrors.email = labels.validEmail;
        }

        if (!patientForm.emergency_contact) {
            newErrors.emergency_contact = labels.emergencyContactRequired;
        } else if (!/^[6-9]\d{9}$/.test(patientForm.emergency_contact)) {
            newErrors.emergency_contact = labels.validMobileNumber;
        }

        if (!patientForm.state_id) {
            newErrors.state_id = labels.stateRequired;
        }

        if (!patientForm.district_id) {
            newErrors.district_id = labels.districtRequired;
        }

        if (!patientForm.dialysis_type_id) {
            newErrors.dialysis_type_id = labels.dialysisTypeRequired;
        }

        if (!patientForm.procedure_type) {
            newErrors.procedure_type = labels.procedureTypeRequired;
        }

        if (patientForm.dialysis_mode !== 0 && patientForm.dialysis_mode !== 1) {
            newErrors.dialysis_mode = labels.dialysisModeRequired;
        }

        if (!patientForm.dialysis_count || isNaN(patientForm.dialysis_count)) {
            newErrors.dialysis_count = labels.dialysisCountRequired;
        }

        if (patientForm.is_bpl !== 0 && patientForm.is_bpl !== 1) {
            newErrors.is_bpl = labels.bplSelectionRequired;
        }

        if (!patientForm.bpl_option_detail) {
            newErrors.bpl_option_detail = labels.bplOptionRequired;
        }

        return newErrors;
    };

    const handleFormChange = (e) => {
        const { name, checked, value } = e.target;
        let finalValue;
        
        if (name === "is_counselled_for_app") {
            finalValue = checked;
        } else if (name === "dialysis_mode" || name === "is_bpl") {
            finalValue = parseInt(value);
        } else {
            finalValue = value;
        }
        
        setPatientForm({
            ...patientForm,
            [name]: finalValue
        });

        // Clear error for the field as the user types
        setErrors({
            ...errors,
            [name]: '',
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formErrors = validate();

        if (Object.keys(formErrors).length === 0) {
            setIsPageLoading(true);
            try {
                const dtresponse = await pmndpAPI.registerPatient(patientForm);
                if (dtresponse.success) {
                    toast.success(dtresponse.message || labels.patientRegistrationSuccess);
                    navigate("/detailsabha");
                } else {
                    toast.error(dtresponse.message || labels.failedRegisterPatient);
                }
            } catch (error) {
                console.error('Registration Error:', error);
                toast.error(labels.errorDuringRegistration);
            } finally {
                setIsPageLoading(false);
            }
        } else {
            setErrors(formErrors);
        }
    };

    return (
        <>
            
            {isPageLoading && <Loader />}
            <div className={styles['pmndp-card']} style={{ marginLeft: 0, marginRight: 0 }}>
                <div className={styles['pmndp-header']}>
                    <div className={styles['pmndp-header-content']}>
                        <div className={styles['pmndp-header-left']}>
                            <div className={styles['pmndp-icon']}>
                                <img src={"/images/PMNDP-logo.png"} alt="" />
                            </div>
                            <h4 className={styles['pmndp-title']}>{labels.pmndpRegistration}</h4>
                        </div>
                        <div className={styles['pmndp-modal-close']} onClick={() => onClose('handleClosepmndpregistration')}>
                            <img src="/images/closing.svg" alt={labels.close} />
                        </div>
                    </div>
                </div>
                <div className={styles['pmndp-modal-body']} style={{ maxHeight: 'none', overflow: 'visible' }}>
                <div className={styles['pmndp-form-section']}>
                    <div className={styles['pmndp-form-section-header']}>
                        <div className={styles['pmndp-form-section-icon']}>👤</div>
                        <h5 className={styles['pmndp-form-section-title']}>{labels.personalDetails}</h5>
                    </div>
                    <div className={styles['pmndp-form-grid']}>
                        <div className="row">
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.registrationDate}<span className="Refre-red">*</span></label>
                                    <input type="date" name="patient_date" defaultValue={patientForm.patient_date} onChange={handleFormChange} />
                                    {errors.patient_date && <p className="error-message-modal">{errors.patient_date}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.patientName}<span className="Refre-red">*</span></label>
                                    <input type="text" name='patient_name' value={patientForm.patient_name} placeholder={labels.enterPatientName} disabled={true} />
                                    {errors.patient_name && <p className="error-message-modal">{errors.patient_name}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.dateOfBirth}<span className="Refre-red">*</span></label>
                                    <input type="date" name='dob' value={patientForm.dob} disabled={true} />
                                    {errors.dob && <p className="error-message-modal">{errors.dob}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.age}<span className="Refre-red">*</span></label>
                                    <input type="text" name='age' value={patientForm.age} disabled={true} />
                                    {errors.age && <p className="error-message-modal">{errors.age}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.patientHeight}<span className="Refre-red">*</span></label>
                                    <input type="number" name='height' value={patientForm.height} onChange={handleFormChange} />
                                    {errors.height && <p className="error-message-modal">{errors.height}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.patientWeight}<span className="Refre-red">*</span></label>
                                    <input type="number" name='weight' value={patientForm.weight} onChange={handleFormChange} />
                                    {errors.weight && <p className="error-message-modal">{errors.weight}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.gender}<span className="Refre-red">*</span></label>
                                    <select name='gender' value={patientForm.gender} onChange={handleFormChange}>
                                        <option value="Male">{labels.male}</option>
                                        <option value="Female">{labels.female}</option>
                                        <option value="Other">{labels.transgender}</option>
                                    </select>
                                    {errors.gender && <p className="error-message-modal">{errors.gender}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="patentsRegFormBox">
                    <h5>{labels.contactDetails}</h5>
                    <div className="innerBoxesFeilds">
                        <div className="row">
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.mobileNumber}<span className="Refre-red">*</span></label>
                                    <input type="text" name='mobile' value={patientForm.mobile} disabled={true} />
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.emailId}</label>
                                    <input type="text" name='email' value={patientForm.email} onChange={handleFormChange} />
                                    {errors.email && <p className="error-message-modal">{errors.email}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.emergencyContactNo}<span className="Refre-red">*</span></label>
                                    <input type="text" name='emergency_contact' value={patientForm.emergency_contact} onChange={handleFormChange} />
                                    {errors.emergency_contact && <p className="error-message-modal">{errors.emergency_contact}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.address}<span className="Refre-red">*</span></label>
                                    <input type="text" name='address' value={patientForm.address} onChange={handleFormChange} />
                                    {errors.address && <p className="error-message-modal">{errors.address}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.state}<span className="Refre-red">*</span></label>
                                    <select name='state_id' onChange={handleStateChange} value={patientForm.state_id}>
                                        <option>{labels.selectState}</option>
                                        {states.map((state) => (
                                            <option key={state.id} value={state.id}>{state.state_name}</option>
                                        ))}
                                    </select>
                                    {errors.state_id && <p className="error-message-modal">{errors.state_id}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.district}<span className="Refre-red">*</span></label>
                                    <select name='district_id' value={patientForm.district_id} onChange={handleFormChange}>
                                        <option>{labels.selectDistrict}</option>
                                        {districts.map((district) => (
                                            <option key={district.district_code} value={district.district_code}>{district.district_name}</option>
                                        ))}
                                    </select>
                                    {errors.district_id && <p className="error-message-modal">{errors.district_id}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="patentsRegFormBox">
                    <h5>{labels.dialysisDetails}</h5>
                    <div className="innerBoxesFeilds">
                        <div className="row">
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.dialysisSupportType} <span className="Refre-red">*</span></label>
                                    <select name='dialysis_type_id' value={patientForm.dialysis_type_id} onChange={handleFormChange}>
                                        <option>{labels.selectType}</option>
                                        {dialysisSupportTypes.map((type) => (
                                            <option key={type.id} value={type.id}>{type.dialysis_type}</option>
                                        ))}
                                    </select>
                                    {errors.dialysis_type_id && <p className="error-message-modal">{errors.dialysis_type_id}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.procedureType}<span className="Refre-red">*</span></label>
                                    <select name='procedure_type' value={patientForm.procedure_type} onChange={handleFormChange}>
                                        <option value="">{labels.selectProcedureType}</option>
                                        {procedureTypes.map((type) => (
                                            <option key={type.id} value={type.code}>{type.name}</option>
                                        ))}
                                    </select>
                                    {errors.procedure_type && <p className="error-message-modal">{errors.procedure_type}</p>}
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.dialysisMode}<span className="Refre-red">*</span></label>
                                    <div className={styles['radioProfile']}>
                                        <label>
                                            <input type="radio" name="dialysis_mode" value={1} onChange={handleFormChange} checked={patientForm.dialysis_mode === 1} />
                                            <span>{labels.hemodialysis}</span>
                                        </label>
                                        <label>
                                            <input type="radio" name="dialysis_mode" value={0} onChange={handleFormChange} checked={patientForm.dialysis_mode === 0} />
                                            <span>{labels.peritonealDialysis}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.recommendedDialysisCount}<span className="Refre-red">*</span></label>
                                    <input type="number" name='dialysis_count' value={patientForm.dialysis_count} onChange={handleFormChange} />
                                    {errors.dialysis_count && <p className="error-message-modal">{errors.dialysis_count}</p>}
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-12">
                                <div className="feild">
                                    <label>
                                        <input type="checkbox" name='is_counselled_for_app' checked={patientForm.is_counselled_for_app === 1} onChange={handleFormChange} />
                                        <span className="ps-2">{labels.patientCounselledApp}</span></label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="patentsRegFormBox">
                    <h5>{labels.otherDetails}</h5>
                    <div className="innerBoxesFeilds">
                        <div className="row">
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.belowPoverty}<span className="Refre-red">*</span></label>
                                    <div className={styles['bplFeilds']}>
                                        <label>
                                            <input type="radio" name='is_bpl' value="1" checked={patientForm.is_bpl === 1} onChange={handleFormChange} />
                                            <span>{labels.yes}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-md-3">
                                <div className="feild">
                                    <label>{labels.bplOption}<span className="Refre-red">*</span></label>
                                    <select name='bpl_option_detail' value={patientForm.bpl_option_detail} onChange={handleFormChange}>
                                        <option>{labels.selectBplOption}</option>
                                        {bploptions.map((option) => (
                                            <option key={option.id} value={option.id}>{option.bpl_list}</option>
                                        ))}
                                    </select>
                                    {errors.bpl_option_detail && <p className="error-message-modal">{errors.bpl_option_detail}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles['pmndp-modal-footer']}>
                    <button type="submit" className={`${styles['pmndp-btn']} ${styles['pmndp-btn-primary']}`} onClick={handleSubmit}>{labels.save}</button>
                </div>
                </div>
            </div>

        </>
    )
}

export default PMNDPRegistrationForm
